import { render, staticRenderFns } from "./jcdmxList.vue?vue&type=template&id=29618e61&scoped=true&"
import script from "./jcdmxList.vue?vue&type=script&lang=js&"
export * from "./jcdmxList.vue?vue&type=script&lang=js&"
import style0 from "./jcdmxList.vue?vue&type=style&index=0&id=29618e61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29618e61",
  null
  
)

export default component.exports